import script from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=2ed7ec2b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed7ec2b"]])

export default __exports__